import React, { Component } from 'react';

import 'react-select/dist/react-select.css';
import 'react-datepicker/dist/react-datepicker.css';

import Criterion from '../components/Criterion';
import {EARLIEST_DATE, LAST_DATE} from '../components/PeriodSelector';
import HistoryView from './HistoryView';
import Footer from '../components/Footer';
import NavigationBar from '../components/NavigationBar';

import SmoothScroll from 'smoothscroll-polyfill';

import FbWrapper from '../lib/FirebaseWrapper';
import DF from 'dateformat';
import './Home.css';
import GA from '../lib/GoogleAnalyticsWrapper'

import ReactPixel from 'react-facebook-pixel';

ReactPixel.init("530483167331860");
const CRITERIA_TYPES = require('../../data/criterionTypes');
const DEFAULT_STOCK_COUNT = 25;
const DEFAULT_STATE = {
  subscriber: '',
  submissionKey: null,
  emailAccount: null,
  submissions: [],
  accountCheck: '',
  quota: 30,
  currentCount: 0,
  selectedTypes: [null],
  selectedValues: [null],
  showAccountInput: false,
  genericInputValues: {
    stockCount: DEFAULT_STOCK_COUNT,
    sortType: null,
    sortOrder: null,
    rebalanceFrequency: "Monthly",
    period: {
      startDate: EARLIEST_DATE,
      endDate: LAST_DATE,
    },
    email: null,
    subscribed: false
  },
  genericInputValidations: {
    sortType: false,
    sortOrder: false,
    email: false,
    period: true
  },
  optionalValidations: [],
  types: CRITERIA_TYPES["LIST"]
};

class Home extends Component {
  constructor(props) {
    super(props);
    SmoothScroll.polyfill();
    this.state = DEFAULT_STATE;

    FbWrapper.checkLimit(function(count) {
      if (count == null) { count = 0 };
      this.setState({ currentCount: count });
    }.bind(this));

    this.addCriterion = this.addCriterion.bind(this);
    this.updateCriterionType = this.updateCriterionType.bind(this);
    this.updateCriterionData = this.updateCriterionData.bind(this);
    this.handleGenericInputChange = this.handleGenericInputChange.bind(this);
    this.handleSubscribeNewsletterChange = this.handleSubscribeNewsletterChange.bind(this);
    this.scrollToForm = this.scrollToForm.bind(this);
  }

  addCriterion() {
    GA.pageview("add-criterion");
    this.state.selectedTypes.push(null);
    this.setState({selectedTypes: this.state.selectedTypes});
  }

  updateCriterionType(index, value) {
    var newTypes = this.state.selectedTypes.slice();
    newTypes[index] = value;
    this.setState({
      selectedTypes: newTypes
    });
  }

  updateCriterionData(index, value) {
    var newValues = this.state.selectedValues.slice();
    newValues[index] = value;
    this.setState({selectedValues: newValues});
  }

  handleSubscribeNewsletterChange(value) {
    const key = "email";

    var checked = value.target.checked;
    this.handleGenericInputChange({name : "subscribed", value : checked});
    var newState;
    if (checked) {
      newState = this.state.optionalValidations.filter((e) => e !== key);
      this.setState({optionalValidations: newState});
    } else {
      newState = this.state.optionalValidations.concat(key);
      this.setState({optionalValidations: newState});
    }
  }

  handleStart() {
    var path = '/picker';
    this.props.history.push(path);
  }

  submitResponse() {
    var data = this.state.genericInputValidations;
    var invalidChecks = [];
    Object.keys(data).map((k) => {
      if (!data[k] && !this.state.optionalValidations.includes(k)) invalidChecks.push(k);
      return null;
    });
    console.log("valid_input? = ", invalidChecks.length===0, invalidChecks);
    if (invalidChecks.length > 0) {
      invalidChecks.map((k) => {
        var msg = k + ' is invalid';
        this.msg.show(msg, {
          time: 2000,
          type: 'error',
          icon: <img src="http://i.imgur.com/C7RBc0g.png" alt="error" style={{width:32, height:32}} />
        });
        return null;
      });
      return;
    }

    var message = {
      email:this.state.genericInputValues.email,
      selectedTypes:this.state.selectedTypes,
      selectedValues:this.state.selectedValues,
      numberOfStocks:this.state.genericInputValues.stockCount,
      sortBy:this.state.genericInputValues.sortType,
      sortOrder:this.state.genericInputValues.sortOrder,
      rebalanceFrequency:this.state.genericInputValues.rebalanceFrequency,
      startDate: DF(new Date(this.state.genericInputValues.period.startDate.toString()), "yyyymmdd"),
      endDate: DF(new Date(this.state.genericInputValues.period.endDate.toString()), "yyyymmdd")
    };
    console.log("message", message, "subscribed", this.state.genericInputValues.subscribed);
    ReactPixel.trackCustom("initiateBacktest", {});
    var email = message.email;
    var submissionKey = FbWrapper.submitResponse(message, email, this.state.genericInputValues.subscribed);
    var path = '/submission/' + submissionKey;
    if (email) { path += '/email/' + email; }
    this.props.history.push(path);
  }

  renderScreeningCriterion() {
    var res = [];
    for (var i = 0; i < this.state.selectedTypes.length; i++) {
      var chosenByOtherDropdowns = [];
      for (var j = 0; j < this.state.selectedTypes.length; j++) {
        if (j !== i) {
          chosenByOtherDropdowns.push(this.state.selectedTypes[j]);
        }
      }
      var options = this.state.types.slice();
      for (var k = 0; k < options.length; k++) {
        var option = options[k];
        if (chosenByOtherDropdowns.indexOf(option) !== -1) {
          option = Object.assign({disabled:true}, option);
          options[k] = option;
        }
      }
      res.push(
        <Criterion
            key={i}
            index={i}
            options={options}
            updateCriterionType={this.updateCriterionType}
            updateCriterionData={this.updateCriterionData}
        />)
    }
    return res;
  }

  renderHistoryPage() {
    return (
      <HistoryView submissions={this.state.submissions}/>
    )
  }

  renderQuestions() {
    if (this.state.currentCount >= this.state.quota) {
      GA.pageview("quota-exceeded");
    }
    let homeCard = () => {
      return (
        this.state.currentCount < this.state.quota ?
        (<div className="container" id="form">
          <div className="counter">
            We have already served {this.state.currentCount} out of {this.state.quota} submissions today. (UTC time)
          </div>
          <div style={{display: 'flex', justifyContent: 'center'}}>
            <a id="suggestion" href="https://goo.gl/forms/LjvY88dilxgSSP0b2" target="_blank" className="btn-secondary" onClick={() => {GA.pageview('suggestions')}}>Suggestions?</a>
            <button className='btn-submit' onClick={() => this.handleStart()}>Start</button>
          </div>
        </div>) : null
      );
    }

    return (
      <div>
        <div className="header">
          <div className="header-wrapper">
            <div className="title">
              Forge Your Own Alpha
            </div>
            <div className="description">
              Have you ever formed your own hypothesis on how to beat the market but wonder if it works?
              <br/>
              We can not predict the future but we sure can help you test the hypothesis in the past.
              <br/>
              <br/>
              <p>
              Tell us how you would like to manage your stock portfolio and we will let you see how it performed between 2002 and 2017, going through two entire bull-bear cycles.
              </p>
            </div>

            <div>
              <a href="https://github.com/ljhskyso/AlphaSmithy/wiki/FAQ" target="_blank" className="btn-secondary" onClick={() => {GA.pageview('faq')}}>FAQ</a>
              <a href="/example" target="_blank" className="btn-secondary" onClick={() => {GA.pageview('sample-page')}}>Actual Sample</a>
              <div className="terms">
                This is our initial version of the product, hence we currently only support up to {this.state.quota} submissions per day.
								{this.state.currentCount >= this.state.quota ? (
									<div>
										We have already served {this.state.currentCount} out of {this.state.quota} submissions today. (UTC time)
										<br/>
										Please come back tomorrow.
									</div>
								) : null}
              </div>
            </div>
          </div>
        </div>
        {homeCard()}
      </div>
    );
  }

  handleGenericInputChange(event) {
    var valid = event.valid || event.valid === undefined;
    var value = valid ? event.value : null;
    var genericInputValues = Object.assign({}, this.state.genericInputValues);
    genericInputValues[event.name] = value;

    var genericInputValidations = Object.assign({}, this.state.genericInputValidations);
    genericInputValidations[event.name] = valid;

    this.setState({genericInputValues, genericInputValidations});
  }

  scrollToForm() {
    var form = document.getElementById('form');
    if (form === null) {
      this.setState(DEFAULT_STATE);
    } else {
      window.scrollBy({ top: form.getBoundingClientRect().top - 48, left: 0, behavior: 'smooth' });
    }
  }

  render() {
    return (
      <div className="body">

        <div className={this.state.currentCount < this.state.quota ? null : "quota-filled"}>
          {this.state.emailAccount ? this.renderHistoryPage() : this.renderQuestions()}
        </div>

        <Footer/>
        <NavigationBar history={this.props.history} scrollToForm={this.scrollToForm}/>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/views/Home.js